import { Toast, ToastType } from './Toast'

type ToastItem = {
  id: string
  message: string
  type: ToastType
}

type ToastContainerProps = {
  toasts: ToastItem[]
  onRemoveToast: (id: string) => void
}

export const ToastContainer = ({ toasts, onRemoveToast }: ToastContainerProps) => {
  return (
    <div className="fixed top-4 right-4 z-50">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={onRemoveToast}
        />
      ))}
    </div>
  )
}
